import ReactDOM from "react-dom";
import { Eye, Trash2, Send } from "lucide-react";

import { TAB_TYPES } from "../constants";

/**
 * Floating Action Menu Component
 * Uses a portal to render at document body level for correct fixed positioning
 */
const ActionMenu = ({ isOpen, item, position, activeTab, onViewTeam, onDelete, onResendInvite, onClose, canManageParticipants = true }) => {
  if (!isOpen || !item) return null;

  const isTeamsTab = activeTab === TAB_TYPES.TEAMS;
  const canView = true; // TODO: restore original condition: item.status === "ACCEPTED" || item.status === "active";
  const canResend = item.status === "PENDING";

  return ReactDOM.createPortal(
    <div
      className="fixed z-[9999] action-menu-popup w-[170px] bg-[#000F1F] border border-[#192634] rounded-2xl shadow-xl overflow-hidden"
      style={{
        top: position.top,
        left: position.left,
      }}
    >
      {/* View Team Page — only for Teams tab */}
      {isTeamsTab && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            if (!canView) return;
            onViewTeam(item.id);
            onClose();
          }}
          disabled={!canView}
          className={`w-full text-left px-4 py-3 text-sm font-medium flex items-center gap-1.5 border-b border-[#192634] transition-colors ${
            canView
              ? "text-[#FEFCEB] hover:bg-[#0D1B29] cursor-pointer"
              : "text-gray-500 cursor-not-allowed opacity-50"
          }`}
        >
          <Eye size={16} />
          View Team Page
        </button>
      )}

      {/* Resend Invite — only for PENDING teams */}
      {canResend && canManageParticipants && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onResendInvite(item);
            onClose();
          }}
          className="w-full text-left px-4 py-3 text-sm font-medium flex items-center gap-1.5 border-b border-[#192634] text-[#FEFCEB] hover:bg-[#0D1B29] transition-colors cursor-pointer"
        >
          <Send size={16} />
          Resend Invite
        </button>
      )}

      {/* Delete */}
      {canManageParticipants && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete(item);
            onClose();
          }}
          className="w-full text-left px-4 py-3 text-red-400 hover:bg-red-500/20 hover:text-red-300 transition-colors text-sm font-medium flex items-center gap-1.5"
        >
          <Trash2 size={16} />
          Delete
        </button>
      )}
    </div>,
    document.body
  );
};

export default ActionMenu;
